import { connect } from 'react-redux'
import { push } from 'connected-react-router'
import * as action from '../../state/search/action'
import * as selector from '../../state/search/selector'
import SalesOrderSearch from './SalesOrderSearch'


const mapStateToProps = state => {
    return {
        tableData: selector.selectShopScanTable(state),
        type: 'shop-scan',
    }
}

const mapDispatchToProps = {
    initialTableQuery: action.initialTableQueryShopScan,
    changeFilter: action.changeFilterShopScan,
    toggleSort: action.toggleSortShopScan,
    toggleMultiSort: action.toggleMultiSortShopScan,
    gotoPage: action.gotoPageShopScan,
    initialColumnsVisibility: action.initialTableSettingsShopScan,
    toggleColumnVisibility: action.toggleColumnVisibilityShopScan,

    navigateToSalesOrder: (salesOrderId) => {
        return push('/sales-order/edit/' + salesOrderId)
    },
}


export default connect(mapStateToProps, mapDispatchToProps)(SalesOrderSearch)



// WEBPACK FOOTER //
// ./src/modules/sales-order/component/search/ShopScanSalesOrderSearchContainer.js